@if (backLink$ | async; as backLink) {
  <a
    class="btn btn-secondary btn-icon"
    trackImpression="button-impression"
    trackImpressionName="aanbod"
    [trackImpressionInfo]="rendering"
    wlTrackLink
    [trackLinkInfo]="{
      rendering: rendering,
      field: 'aanbod',
      linkurl: backLink.href,
      eventType: 'button-click',
    }"
    *wlGenericLink="
      { value: backLink };
      extras: { queryParamsHandling: 'preserve' }
    "
    wlCSCapture
  >
    <crnt-icon icon="pen"></crnt-icon>
  </a>
}
